<template>
  <TeachTableDisplayPanel
    title="การแสดงในหน้าตารางสอนชั้นปี"
    subtitle="กรณีเปิดให้หลายสาขาหรือหลายชั้นปี , สอนบริการ , Gened"
    :columns="[{ text: 'คณะ', value: 'FACULTY_NAME_TH' }, { text: 'ภาควิชา', value: 'DEPARTMENT_NAME_TH' }, { text: 'สาขาวิชา', value: 'CURRICULUM2_NAME_TH' }, { text: 'ชั้นปีที่', value: 'CLASS_TEXT_TH' }]"
    :rows="all_show_slot_with_name"
    :can-add="enable_add"
    @add="add_new_show_slot"
    @remove="remove_show_slot"
  >
        <autocomplete
          :data="registrar_faculties"
          label="คณะ"
          data_id="faculty_id"
          data_name="faculty_name"
          :selected_value="appear_registrar_faculty_id"
          @update_selected_value="(val) => (appear_registrar_faculty_id = val)"
          :can_select_all="false"
          :lower_case="true"
        />
        <autocomplete
          :data="filteredDepartments"
          data_id="department_id"
          data_name="department_name"
          label="ภาควิชา"
          search_all_label="เลือกทุกภาควิชา"
          :selected_value="appear_registrar_dept_id"
          @update_selected_value="(val) => (appear_registrar_dept_id = val)"
          :select_searh_all="appear_all_department"
          @update_select_search_all_value="
            (val) => (appear_all_department = val)
          "
          :can_select_all="true"
          :lower_case="true"
        />
        <autocomplete
          :data="filteredCurriculums"
          data_id="curriculum_id"
          data_name="curriculum_name"
          label="หลักสูตร"
          search_all_label="เลือกทุกหลักสูตร"
          :disable_select_all="appear_all_department"
          :selected_value="appear_registrar_curr2_id"
          @update_selected_value="(val) => (appear_registrar_curr2_id = val)"
          :select_searh_all="appear_all_curriculum2"
          @update_select_search_all_value="
            (val) => (appear_all_curriculum2 = val)
          "
          :can_select_all="true"
          :lower_case="true"
        />
        <autocomplete
          :data="classes"
          label="ชั้นปี"
          search_all_label="เลือกทุกชั้นปี"
          :selected_value="appear_registrar_class"
          @update_selected_value="(val) => (appear_registrar_class = val)"
          :select_searh_all="appear_all_class_year"
          @update_select_search_all_value="
            (val) => (appear_all_class_year = val)
          "
          :can_select_all="true"
        />

  </TeachTableDisplayPanel>
</template>

<script>
import TeachTableDisplayPanel from "./TeachTableDisplayPanel.vue";
import { objectTranslator, inlineTranslator } from "@/helper/translator";
// import RefProvider from "@/services/ref.provider";
import { listFilter } from "@/helper/filter";
// const refService = new RefProvider();
import genericProvider from "@/services/generic.provider.js";
const genericService = new genericProvider();
import ConfigTeachTableProvider from "@/services/config_teach_table.provider.js";
const ConfigTeachTableService = new ConfigTeachTableProvider();
// import { getById } from "@/helper/filter";
import Autocomplete from "@/views/teach_table/components/Autocomplete.vue";

export default {
  name: "ConfigShowTeachTablePanel",
  components: { TeachTableDisplayPanel, Autocomplete },
  props: ["year", "semester", "value"],
  data: () => ({
    level_id: 1,
    appear_registrar_faculty_id: null,
    appear_registrar_dept_id: null,
    appear_registrar_curr2_id: null,
    appear_registrar_class: null,

    appear_all_department: false,
    appear_all_curriculum2: false,
    appear_all_class_year: false,

    show_in_class_table: true,

    registrar_faculties: [],
    registrar_departments: [],
    registrar_curriculums: [],

    classes: ["1", "2", "3", "4", "5", "6"],
  }),
  computed: {
    can_view_show_in_teach_table() {
      const { user } = this.$store.state;
      if (
        user &&
        user.user_info &&
        user.user_info.payload &&
        user.user_info.payload.ticket
      ) {
        const privilege = user.user_info.payload.ticket.privilege;
        return privilege == 91 || privilege == 40 || privilege == 19;
      }
      return false;
    },
    all_show_slot: {
      get() {
        return this.value;
      },
      set(e) {
        return this.$emit("input", e);
      },
    },
    enable_add() {
      return (
        this.appear_registrar_faculty_id &&
        (this.appear_registrar_dept_id || this.appear_all_department) &&
        (this.appear_registrar_curr2_id || this.appear_all_curriculum2) &&
        (this.appear_registrar_class || this.appear_all_class_year)
      );
    },
    filteredDepartments() {
      if (!this.appear_registrar_faculty_id) return [];
      return this.registrar_departments.filter(
        (item) => item.faculty_id === this.appear_registrar_faculty_id
      );
    },
    filteredCurriculums() {
      if (!this.appear_registrar_dept_id) return [];
      return this.registrar_curriculums.filter(
        (item) =>
          item.dept_id === this.appear_registrar_dept_id &&
          item.faculty_id === this.appear_registrar_faculty_id
      );
    },
    all_show_slot_with_name() {
      return this.all_show_slot.map((slot) => {
        const fac = this.registrar_faculties.find(
          (item) => item.faculty_id === slot.FACULTY_ID
        );
        const dep = this.registrar_departments.find(
          (item) =>
            item.department_id === slot.DEPARTMENT_ID &&
            item.faculty_id === slot.FACULTY_ID
        );
        const cur = this.registrar_curriculums.find(
          (item) =>
            item.curriculum_id === slot.CURRICULUM2_ID &&
            item.faculty_id === slot.FACULTY_ID
        );

        let FACULTY_NAME_TH = fac ? fac.faculty_name_th : "-";
        let FACULTY_NAME_EN = fac ? fac.faculty_name_en : "-";
        let DEPARTMENT_NAME_TH = dep
          ? dep.department_name_th
          : slot.DEPARTMENT_ID === "x"
          ? "ทุกภาควิชา"
          : "-";
        let DEPARTMENT_NAME_EN = dep
          ? dep.department_name_en
          : slot.DEPARTMENT_ID === "x"
          ? "ทุกภาควิชา"
          : "-";
        let CURRICULUM2_NAME_TH = cur
          ? cur.curriculum_name_th
          : slot.CURRICULUM2_ID === "x"
          ? "ทุกสาขา"
          : "-";
        let CURRICULUM2_NAME_EN = cur
          ? cur.curriculum_name_en
          : slot.CURRICULUM2_ID === "x"
          ? "ทุกสาขา"
          : "-";

        let CLASS_TEXT_TH =
          slot.CLASS !== "x" && slot.CLASS !== "0" ? slot.CLASS : "ทุกชั้นปี";
        let CLASS_TEXT_EN =
          slot.CLASS !== "x" && slot.CLASS !== "0" ? slot.CLASS : "ทุกชั้นปี";
        return {
          ...slot,
          FACULTY_NAME_TH,
          FACULTY_NAME_EN,
          DEPARTMENT_NAME_TH,
          DEPARTMENT_NAME_EN,
          CURRICULUM2_NAME_TH,
          CURRICULUM2_NAME_EN,
          CLASS_TEXT_TH,
          CLASS_TEXT_EN,
        };
      });
    },
  },
  methods: {
    objectTranslator,
    inlineTranslator,
    listFilter,
    show_backend_error(error) {
      const data = error && error.response && error.response.data;
      const message =
        data && data.message
          ? data.message
          : error && error.message
          ? error.message
          : this.$t("config_teach_table.save_unsuccessfully");
      this.$toasted.error(
        typeof message === "string" ? message : JSON.stringify(message),
        { duration: 0 }
      );
    },

    async add_new_show_slot() {
      this.all_show_slot = [
        ...this.all_show_slot,
        {
          YEAR: this.year,
          SEMESTER: this.semester,
          FACULTY_ID: this.appear_registrar_faculty_id,
          SHOW_IN_CLASS_TABLE: this.show_in_class_table,
          DEPARTMENT_ID: this.appear_all_department
            ? "x"
            : this.appear_registrar_dept_id,
          CURRICULUM2_ID: this.appear_all_curriculum2
            ? "x"
            : this.appear_registrar_curr2_id,
          CLASS: this.appear_all_class_year ? "x" : this.appear_registrar_class,
        },
      ];
    },
    remove_show_slot(index) {
      this.all_show_slot.splice(index, 1);
    },
    async save_to_db(level_id, teach_table_id) {
      const response = await ConfigTeachTableService.setTeachTableAppear({
        level_id,
        teach_table_id,
        year: this.year,
        semester: this.semester,
        all_teach_table_appear: this.all_show_slot,
      }).catch((error) => {
        this.show_backend_error(error);
        return null;
      });

      if (response && response.status) {
        this.$toasted.success(
          this.$t("config_teach_table.save_teachtable_show_successfully"),
          {
            duration: 0,
          }
        );
        return true;
      }
      return false;
    },
    async new_default_show_slot({
      year,
      semester,
      faculty_id,
      department_id,
      curriculum2_id,
      year_class,
    }) {
      const default_show_slot = [
        {
          YEAR: year,
          SEMESTER: semester,
          FACULTY_ID: faculty_id,
          DEPARTMENT_ID: department_id,
          CURRICULUM2_ID: curriculum2_id,
          CLASS: year_class,
          SHOW_IN_CLASS_TABLE: true,
        },
      ];
      this.all_show_slot = default_show_slot;
    },
    async get_show_slot(level_id, teach_table_id) {
      const data = await ConfigTeachTableService.getTeachTableAppear({
        level_id,
        teach_table_id,
      });
      this.all_show_slot = data.all_teach_table_appear;
    },

    //===========================================================

    async init_data() {
      const faculties = await genericService.getRegistrarFaculty();
      this.registrar_faculties = faculties;

      const departments = await genericService.getAllRegistrarDepartment();
      this.registrar_departments = departments;

      const curriculums = await genericService.getAllRegistrarBachelorCurriculum();
      this.registrar_curriculums = curriculums;
    },
  },
  async mounted() {
    try {
      await this.init_data();
    } catch (error) {
      this.show_backend_error(error);
    }
  },
  created() {},
  watch: {
    appear_registrar_faculty_id() {
      this.appear_registrar_dept_id = null;
    },
    appear_registrar_dept_id() {
      this.appear_registrar_curr2_id = null;
    },
    appear_all_department(val) {
      if (val) {
        this.appear_all_curriculum2 = true;
        this.appear_registrar_dept_id = null;
      }
    },
    appear_all_curriculum2(val) {
      if (val) {
        this.appear_registrar_curr2_id = null;
      }
    },
    appear_all_class_year(val) {
      if (val) {
        this.appear_registrar_class = null;
      }
    },
  },
};
</script>
